module.exports = __webpack_public_path__ + "img/cbr-file.7b0fb8c8.svg";